export const PROPERTIES = {
  AUTHOR_EMAIL: 'hs_author_email',
  AUTHOR_NAME: 'hs_author_name',
  ARCHIVED: 'hs_archived',
  CONTENT_ID: 'hs_content_id',
  NAME: 'hs_name',
  NUMBER_CONTACT: 'hs_number_contact_property',
  PUBLISH_DATE: 'hs_publish_date',
  SMS_TYPE: 'hs_sms_type',
  SMS_STATE: 'hs_state',
  SUBCATEGORY: 'hs_subcategory',
  CREATED_DATE: 'hs_createdate',
  LAST_UPDATED_DATE: 'hs_updated_at',
  TEAM_IDS: 'hs_all_team_ids',
  USER_IDS: 'hs_user_ids_of_all_owners',
  OBJECT_ID: 'hs_object_id',
  CAMPAIGN_NAME: 'hs_campaign_name',
  PUBLISH_STATUS: 'hs_publish_status',
  DELIVERED: 'hs_delivered',
  CLICK_RATE: 'hs_click_rate',
  CREATED_BY_USER_ID: 'hs_created_by_user_id',
  UPDATED_BY_USER_ID: 'hs_updated_by_user_id',
  SENDS: 'hs_sends',
  FAILED_SENDS: 'hs_failed_sends',
  FAILED_DELIVERED: 'hs_failed_delivered',
  CLICKS: 'hs_total_clicks',
  ROOT_MIC_ID: 'hs_root_mic_id',
  PREVIEW_KEY: 'hs_preview_key',
  ATTACHED_MEDIA: 'hs_attached_media',
  ENABLED: 'hs_enabled',
  SECURITY_STATE: 'hs_security_state',
  GENERATED_BY_AI: 'hs_generated_by_ai',
  GENERATED_WITH_AI: 'hs_generated_with_ai',
  IS_AI_USED: 'hs_is_ai_used',
  RECORD_SOURCE_DETAILS_1: 'hs_object_source_detail_1',
  RECORD_SOURCE_DETAILS_2: 'hs_object_source_detail_2',
  RECORD_SOURCE_DETAILS_3: 'hs_object_source_detail_3',
  PUBLISH_AUTHOR_ID: 'hs_publish_author',
  PUBLISH_BY_EMAIL: 'hs_published_by_email',
  PUBLISH_BY_NAME: 'hs_published_by_name',
  HS_LAST_MODIFIED_DATE: 'hs_lastmodifieddate',
  OWNER_ASSIGN_DATE: 'hubspot_owner_assigneddate',
  MERGED_OBJECT_IDS: 'hs_merged_object_ids',
  HS_TEAM_ID: 'hubspot_team_id',
  HS_OWNER_ID: 'hubspot_owner_id',
  SUBSCRIPTION: 'hs_subscription'
};
export const DRAFT = 'DRAFT';
export const AUTOMATED_DRAFT = 'AUTOMATED_DRAFT';
export const PUBLISHED = 'PUBLISHED';
export const SCHEDULED = 'SCHEDULED';
export const PROCESSING = 'PROCESSING';
export const PRE_PROCESSING = 'PRE_PROCESSING';
export const ERROR = 'ERROR';
export const AUTOMATED = 'AUTOMATED';
export const AUTOMATED_SEND = 'AUTOMATED_SEND';
export const SENT = 'SENT';
export const SMS_STATE = {
  DRAFT,
  SCHEDULED,
  PROCESSING,
  PRE_PROCESSING,
  ERROR,
  SENT,
  AUTOMATED,
  AUTOMATED_DRAFT
};
export const BATCH_SMS_STATE = {
  DRAFT,
  SCHEDULED,
  PROCESSING,
  PRE_PROCESSING,
  ERROR,
  SENT
};
export const AUTOMATED_SMS_STATE = {
  AUTOMATED,
  AUTOMATED_DRAFT
};
export const HS_PUBLISH_STATUS = {
  //TODO: migrate the usage of HS_PUBLISH_STATUS to use SMS_STATE and revamp the property here
  DRAFT,
  SCHEDULED,
  PUBLISHED,
  PROCESSING,
  PRE_PROCESSING,
  ERROR,
  AUTOMATED
};
export const BATCH_SMS_STATUS = {
  DRAFT,
  SCHEDULED,
  PROCESSING,
  PRE_PROCESSING,
  ERROR,
  SENT
};
export const AUTOMATED_SMS_STATUS = {
  AUTOMATED_DRAFT,
  AUTOMATED,
  PUBLISHED,
  ERROR
};
export const SEND_TO_MORE = 'SEND_TO_MORE';
export const SEND_TYPE = {
  SEND_TO_MORE,
  AUTOMATED_SEND
};
export const SMS_SUBCATEGORY = {
  AUTOMATED: 'automated'
};
const CLEAR = 'CLEAR';
const NONE = 'NONE';
const FLAGGED_FOR_REVIEW = 'FLAGGED_FOR_REVIEW';
const SECURITY_VIOLATION = 'SECURITY_VIOLATION';
export const SMS_SECURITY_REVIEW_STATUS = {
  CLEAR,
  NONE,
  FLAGGED_FOR_REVIEW,
  SECURITY_VIOLATION
};
export const MIN_QUIET_HOURS_TIME = 8 * 60;
export const MAX_QUIET_HOURS_TIME_OPTION = 19.5 * 60;
export const MAX_QUIET_HOURS_TIME = 19.99 * 60;
export const QUIET_HOURS_KB_URL = 'https://knowledge.hubspot.com/sms/understand-sms-quiet-hours';